import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import "./index.scss";
import CategoryService from "../../../services/category";
import ProductService from "../../../services/product"; // Nouveau service pour récupérer les produits
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import Select from "react-select";

const categoryService = new CategoryService();
const productService = new ProductService();

const AddProduct = () => {
  const [productData, setProductData] = useState({
    title: "",
    slug: "",
    reference: "",
    description: "",
    categoryId: "",
    quantite: 0,
    prixHorsTax: 0,
    tva: 0,
    ttc: 0,
    isOnPromo: false,
    pourcentagePromo: 0,
    ttcFinal: 0,
    promoStartDate: "",
    promoEndDate: "",
    status: true,
    produitType: "",
    stockEnStock: true,
    stockRupture: false,
    stockAttenteLivraison: false,
    bienfaits: [],
    utilisation: [],
    activeClee: [{ titre: "", description: "", image: null }],
    produitsAssocies: [],
    imageSecondaire: null, // ✅ nouveau champ image
  });

  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [imagePrincipale, setImagePrincipale] = useState([]);
  const [listeImage, setListeImage] = useState([]);
  const [imageSecondaire, setImageSecondaire] = useState(null); // ✅
  const [isLoading, setIsLoading] = useState(true);

  // Gestion des champs texte / checkbox / radio
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    if (name === "prixHorsTax" || name === "tva") {
      const prixHorsTax =
        name === "prixHorsTax"
          ? parseFloat(newValue) || 0
          : parseFloat(productData.prixHorsTax) || 0;
      const tva =
        name === "tva"
          ? parseFloat(newValue) || 0
          : parseFloat(productData.tva) || 0;
      const ttc = prixHorsTax + (prixHorsTax * tva) / 100;
      const ttcFinal = productData.isOnPromo
        ? ttc - (ttc * (productData.pourcentagePromo || 0)) / 100
        : ttc;

      setProductData({
        ...productData,
        [name]: newValue,
        ttc: parseFloat(ttc.toFixed(3)),
        ttcFinal: parseFloat(ttcFinal.toFixed(3)),
      });
    } else if (name === "pourcentagePromo") {
      const promo = parseFloat(newValue) || 0;
      const ttcFinal = productData.ttc - (productData.ttc * promo) / 100;
      setProductData({
        ...productData,
        pourcentagePromo: promo,
        ttcFinal: parseFloat(ttcFinal.toFixed(3)),
      });
    } else if (name === "isOnPromo") {
      const isOnPromo = checked;
      const ttcFinal = isOnPromo
        ? productData.ttc -
          (productData.ttc * (productData.pourcentagePromo || 0)) / 100
        : productData.ttc;
      setProductData({
        ...productData,
        isOnPromo,
        ttcFinal: parseFloat(ttcFinal.toFixed(3)),
      });
    } else if (name === "produitsAssocies") {
      const selectedOptions = Array.from(e.target.selectedOptions).map(
        (opt) => opt.value
      );
      setProductData({
        ...productData,
        produitsAssocies: selectedOptions,
      });
    } else {
      setProductData({
        ...productData,
        [name]: newValue,
      });
    }
  };

  // Charger catégories et produits
  const loadData = async () => {
    setIsLoading(true);
    try {
      const resCategories = await categoryService.getAllCategories();
      setCategories(resCategories?.data);

      const resProducts = await productService.getAllProducts();
      setProducts(resProducts?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  // Bienfaits et utilisation
  const handleBienfaitsChange = (e) => {
    setProductData({ ...productData, bienfaits: e.target.value.split(",") });
  };
  const handleUtilisationChange = (e) => {
    setProductData({ ...productData, utilisation: e.target.value.split(",") });
  };

  // Active Clee
  const handleActiveCleeChange = (index, e) => {
    const { name, value, files } = e.target;
    const newActiveClee = [...productData.activeClee];
    if (name === "image") {
      newActiveClee[index][name] = files[0];
    } else {
      newActiveClee[index][name] = value;
    }
    setProductData({ ...productData, activeClee: newActiveClee });
  };
  const addActiveClee = () => {
    setProductData({
      ...productData,
      activeClee: [
        ...productData.activeClee,
        { titre: "", description: "", image: null },
      ],
    });
  };
  const removeActiveClee = (index) => {
    const newActiveClee = productData.activeClee.filter((_, i) => i !== index);
    setProductData({ ...productData, activeClee: newActiveClee });
  };

  // Envoi formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    Object.keys(productData).forEach((key) => {
      if (
        key === "bienfaits" ||
        key === "utilisation" ||
        key === "produitsAssocies"
      ) {
        formData.append(key, JSON.stringify(productData[key]));
      } else if (
        key !== "activeClee" &&
        key !== "produitType" &&
        key !== "imageSecondaire"
      ) {
        formData.append(key, productData[key]);
      }
    });

    formData.set("isBestSeller", productData.produitType === "bestSeller");
    formData.set("isBientotDispo", productData.produitType === "bientotDispo");
    formData.set("isNouveaux", productData.produitType === "nouveaux");

    formData.set("onStock", !!productData.stockEnStock);
    formData.set("stockRupture", !!productData.stockRupture);
    formData.set("stockAttenteLivraison", !!productData.stockAttenteLivraison);

    if (productData.isOnPromo) {
      formData.set("promoStartDate", productData.promoStartDate);
      formData.set("promoEndDate", productData.promoEndDate);
    }

    imagePrincipale.forEach((file) =>
      formData.append("imagesPrincipales", file)
    );
    listeImage.forEach((file) => formData.append("listeImage", file));

    if (imageSecondaire) {
      formData.append("image", imageSecondaire);
    }

    productData.activeClee.forEach((item, index) => {
      formData.append(`activeClee[${index}][titre]`, item.titre);
      formData.append(`activeClee[${index}][description]`, item.description);
      if (item.image instanceof File)
        formData.append(`activeClee[${index}][image]`, item.image);
    });

    try {
      const res = await axios.post("https://api.almasecret.msit-demo.fr/products", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Produit ajouté avec succès !");
    } catch (err) {
      console.error(err);
      alert("Erreur lors de l'ajout du produit");
    }
  };

  return (
    <Form className="add-product-form" onSubmit={handleSubmit}>
      {/* Détails généraux */}
      <div className="card-details">
        <h5>Détails généraux du produit</h5>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group controlId="title">
              <Form.Label>Titre</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={productData.title}
                onChange={handleChange}
                required
                placeholder="Saisir le nom du produit"
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group controlId="slug">
              <Form.Label>Lien permanent</Form.Label>
              <Form.Control
                type="text"
                name="slug"
                value={productData.slug}
                onChange={handleChange}
                required
                placeholder="https://api.almasecret.msit-demo.fr/produit"
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group controlId="reference" className="mb-3">
          <Form.Label>Référence produit</Form.Label>
          <Form.Control
            type="text"
            name="reference"
            value={productData.reference}
            onChange={handleChange}
            placeholder="Référence interne du produit"
          />
        </Form.Group>
        <Form.Group controlId="description" className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="description"
            value={productData.description}
            onChange={handleChange}
            placeholder="Saisir la description du produit"
          />
        </Form.Group>
        <Form.Group controlId="categoryId" className="mb-3">
          <Form.Label>Catégorie</Form.Label>
          <Form.Select
            name="categoryId"
            value={productData.categoryId}
            onChange={handleChange}
            required>
            <option value="">-- Sélectionner une catégorie --</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat._id}>
                {cat.title}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group controlId="imagePrincipale" className="mb-3">
          <Form.Label>Images principales</Form.Label>
          <Form.Control
            type="file"
            multiple
            onChange={(e) => setImagePrincipale([...e.target.files])}
          />
        </Form.Group>

        {/* ✅ Nouveau champ image secondaire */}
      </div>

      {/* Détails tarifaires */}
      <div className="card-details mt-4">
        <h5>Détails tarifaires</h5>
        <Row>
          <Col md={4}>
            <Form.Group controlId="prixHorsTax" className="mb-3">
              <Form.Label>Prix HT</Form.Label>
              <Form.Control
                type="number"
                name="prixHorsTax"
                value={productData.prixHorsTax}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="tva" className="mb-3">
              <Form.Label>TVA (%)</Form.Label>
              <Form.Control
                type="number"
                name="tva"
                value={productData.tva}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="ttc" className="mb-3">
              <Form.Label>TTC</Form.Label>
              <Form.Control
                type="number"
                name="ttc"
                value={productData.ttc}
                disabled
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group controlId="isOnPromo" className="mb-3">
          <Form.Check
            type="checkbox"
            label="En promotion"
            name="isOnPromo"
            checked={productData.isOnPromo}
            onChange={handleChange}
          />
        </Form.Group>

        {productData.isOnPromo && (
          <>
            <Form.Group controlId="pourcentagePromo" className="mb-3">
              <Form.Label>Pourcentage promo</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control
                  type="number"
                  name="pourcentagePromo"
                  value={productData.pourcentagePromo}
                  onChange={handleChange}
                  style={{ maxWidth: "150px", marginRight: "10px" }}
                />
                <span>
                  Prix TTC après promo :{" "}
                  <strong>{productData.ttcFinal.toFixed(3)}</strong> DT
                </span>
              </div>
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group controlId="promoStartDate" className="mb-3">
                  <Form.Label>Date de début de promotion</Form.Label>
                  <Form.Control
                    type="date"
                    name="promoStartDate"
                    value={productData.promoStartDate}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="promoEndDate" className="mb-3">
                  <Form.Label>Date de fin de promotion</Form.Label>
                  <Form.Control
                    type="date"
                    name="promoEndDate"
                    value={productData.promoEndDate}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        )}

        <Form.Group controlId="ttcFinal" className="mb-3">
          <Form.Label>TTC Final</Form.Label>
          <Form.Control
            type="number"
            name="ttcFinal"
            value={productData.ttcFinal}
            disabled
          />
        </Form.Group>
      </div>
      <div className="card-details mt-4">
        <h5>État des stocks</h5>
        {/* Quantité et status */}
        <Row>
          <Col md={12}>
            <Form.Group controlId="quantite" className="mb-3">
              <Form.Label>Quantité</Form.Label>
              <Form.Control
                type="number"
                name="quantite"
                value={productData.quantite}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Stock (radio booléens) */}
        <Form.Group controlId="stockStatus" className="mb-3">
          <Form.Label>Statut du stock</Form.Label>
          <div>
            <Form.Check
              type="radio"
              label="En stock"
              name="stockStatus"
              checked={productData.stockEnStock}
              onChange={() =>
                setProductData({
                  ...productData,
                  stockEnStock: true,
                  stockRupture: false,
                  stockAttenteLivraison: false,
                })
              }
              inline
            />
            <Form.Check
              type="radio"
              label="Rupture de stock"
              name="stockStatus"
              checked={productData.stockRupture}
              onChange={() =>
                setProductData({
                  ...productData,
                  stockEnStock: false,
                  stockRupture: true,
                  stockAttenteLivraison: false,
                })
              }
              inline
            />
            <Form.Check
              type="radio"
              label="En attente de livraison"
              name="stockStatus"
              checked={productData.stockAttenteLivraison}
              onChange={() =>
                setProductData({
                  ...productData,
                  stockEnStock: false,
                  stockRupture: false,
                  stockAttenteLivraison: true,
                })
              }
              inline
            />
          </div>
        </Form.Group>
      </div>
      <div className="card-details mt-4">
        <h5>Informations complémentaires</h5>
        {/* Type de produit (radio) */}
        <Col md={6}>
          <Form.Group controlId="status" className="mb-3">
            <Form.Check
              type="checkbox"
              label="Produit publié"
              name="status"
              checked={productData.status}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Form.Group controlId="produitType" className="mb-3">
          <Form.Label>Type de produit</Form.Label>
          <div>
            <Form.Check
              type="radio"
              label="Best Seller"
              name="produitType"
              value="bestSeller"
              checked={productData.produitType === "bestSeller"}
              onChange={handleChange}
              inline
            />
            <Form.Check
              type="radio"
              label="Bientôt disponible"
              name="produitType"
              value="bientotDispo"
              checked={productData.produitType === "bientotDispo"}
              onChange={handleChange}
              inline
            />
            <Form.Check
              type="radio"
              label="Nouveau produit"
              name="produitType"
              value="nouveaux"
              checked={productData.produitType === "nouveaux"}
              onChange={handleChange}
              inline
            />
          </div>
        </Form.Group>

        {/* Bienfaits */}
        <Form.Group controlId="bienfaits" className="mb-3">
          <Form.Label>Bienfaits (séparés par une virgule)</Form.Label>
          <Form.Control
            type="text"
            value={productData.bienfaits.join(",")}
            onChange={handleBienfaitsChange}
          />
        </Form.Group>
        <Form.Group controlId="imageSecondaire" className="mb-3">
          <Form.Label>Image Utilisation</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => {
              setImageSecondaire(e.target.files[0]);
              setProductData({
                ...productData,
                imageSecondaire: e.target.files[0],
              });
            }}
          />
        </Form.Group>
        {/* Utilisation */}
        <Form.Group controlId="utilisation" className="mb-3">
          <Form.Label>Utilisation (séparées par une virgule)</Form.Label>
          <Form.Control
            type="text"
            value={productData.utilisation.join(",")}
            onChange={handleUtilisationChange}
          />
        </Form.Group>

        {/* Liste images */}
        <Form.Group controlId="listeImage" className="mb-3">
          <Form.Label>Liste d'images</Form.Label>
          <Form.Control
            type="file"
            multiple
            onChange={(e) => setListeImage([...e.target.files])}
          />
        </Form.Group>

        {/* Active Clé */}
        <h5 className="mt-3">Active Clé</h5>
        {productData.activeClee.map((item, index) => (
          <div key={index} className="active-cle-item mb-2">
            <Row>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Titre"
                  name="titre"
                  value={item.titre}
                  onChange={(e) => handleActiveCleeChange(index, e)}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Description"
                  name="description"
                  value={item.description}
                  onChange={(e) => handleActiveCleeChange(index, e)}
                />
              </Col>
              <Col md={3}>
                <Form.Control
                  type="file"
                  name="image"
                  onChange={(e) => handleActiveCleeChange(index, e)}
                />
              </Col>
              <Col md={1}>
                <Button
                  variant="danger"
                  onClick={() => removeActiveClee(index)}>
                  X
                </Button>
              </Col>
            </Row>
          </div>
        ))}
        <Button variant="secondary" onClick={addActiveClee} className="mb-3">
          Ajouter un activeClé
        </Button>
      </div>
      <div className="card-details mt-4">
        <Form.Group controlId="produitsAssocies" className="mb-3">
          <Form.Label>Produits associés</Form.Label>
          <Select
            isMulti
            name="produitsAssocies"
            options={products.map((prod) => ({
              value: prod._id,
              label: prod.title,
            }))}
            className="basic-multi-select"
            classNamePrefix="select"
            value={products
              .map((prod) => ({
                value: prod._id,
                label: prod.title,
              }))
              .filter((opt) =>
                productData.produitsAssocies.includes(opt.value)
              )}
            onChange={(selectedOptions) => {
              setProductData({
                ...productData,
                produitsAssocies: selectedOptions.map((opt) => opt.value),
              });
            }}
          />
        </Form.Group>{" "}
      </div>

      <Button variant="primary" type="submit" className="mt-3">
        Ajouter le produit
      </Button>
    </Form>
  );
};

export default AddProduct;
